import type { FC } from 'react'

import { Routes, Route } from 'react-router-dom'

import { Activities } from './Activities'
import { EndOfLease } from './end-of-lease'
import { ReturnDevice } from './ReturnDevice/ReturnDevice'

export const ActivityRoutes: FC = () => (
  <div className="bg-white transition-all duration-200 ease-in">
    <Routes>
      <Route path="end-of-lease/:id" element={<EndOfLease />} />
      <Route path="return-device/:id" element={<ReturnDevice />} />
      <Route path="/" element={<Activities />} />
    </Routes>
  </div>
)
